import axiosClient from "./ApiInstance";
import Cookies from "js-cookie";
import { ImageValidation } from "./common";

export const GET = async (url, data) => {
  // try {
  return await axiosClient.get(process.env.REACT_APP_BASE_URL + url, data);
  // } catch (error) {
  //   console.error(error.message);
  // }
};

export const POST = async (url, data) => {
  // try {
  return await axiosClient.post(process.env.REACT_APP_BASE_URL + url, data);
  // } catch (error) {
  //   console.error(error.message);
  // }
};

export const PUT = async (url, data) => {
  // try {
  return await axiosClient.put(process.env.REACT_APP_BASE_URL + url, data);
  // } catch (error) {
  //   console.error(error.message);
  // }
};

export const EditStatus = async (url) => {
  // try {
  return await axiosClient.put(process.env.REACT_APP_BASE_URL + url);
  // } catch (error) {
  //   console.error(error.message);
  // }
};

export const DELETE = async (url) => {
  // try {
  return await axiosClient.delete(process.env.REACT_APP_BASE_URL + url);
  // } catch (error) {
  //   console.error(error.message);
  // }
};

// Download Apis
export const DownloadExcel = async (aurl, data, name) => {
  try {
    const response = await axiosClient.post(
      process.env.REACT_APP_BASE_URL + aurl,
      data,
      {
        responseType: "blob", // Set responseType to "blob"
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    // Create a temporary anchor element to trigger the download
    const link = (document.crwarri_sport_admin_security.href = url);
    link.setAttribute(
      "download",
      `${name + " " + new Date().toLocaleDateString()}.xlsx`
    );
    document.body.appendChild(link);
    link.click();

    // Clean up after the download
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error.message);
  }
};

export const getDimension = async (file, w, h) => {
  try {
    let reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new DOMException("Problem parsing input file."));
      };

      reader.onload = () => {
        var image = new Image();
        image.src = reader.result;
        image.onload = function () {
          resolve({ width: this.width, height: this.height });
        };
      };
      reader.readAsDataURL(file);
    });
  } catch (error) {
    console.error(error.message);
  }
};

export const ValidationImage = async (value, w, h) => {
  try {
    if (typeof value !== "string") {
      const fileTypes = ImageValidation?.files_type;
      const fileType = value[0]?.name?.split(".")[1];

      if (!fileTypes.includes(fileType)) {
        return `please upload a valid file format. (${fileTypes})`;
      }

      const sizes = await getDimension(value[0]);
      if (sizes.width !== w && sizes.height !== h) {
        return `Image width and height must be ${w} px and ${h} px`;
      }
    }
  } catch (error) {
    console.error(error.message);
  }
};
